import React, { Component } from 'react'
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Button,
  InputGroup,
  Input,
  Label,
  InputGroupButton,
  Form
} from 'reactstrap'
import { Link } from 'react-router-dom'

import Auth from '../../modules/Auth'
import { get } from '../../modules/API'

class Profiles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      count: null,
      next: null,
      previous: null,
      results: []
    }

    this.searchOffice = this.searchOffice.bind(this)
  }

  componentDidMount() {
    if (Auth.isUserAuthenticated()) {
      get(`sales-profiles?manager_id=${this.props.userInfo.id}`)
        .then(data => {
          this.setState({
            loaded: true,
            ...data,
            isSearchable: data.results.length > 5
          })
        })
    }
  }

  searchOffice(ev) {
    ev.preventDefault()

    let searchTerm = this.search.value

    get(`sales-profiles?manager_id=${this.props.userInfo.id}&office_name__contains=${searchTerm}`)
    .then(data => {
      this.setState({ ...data })
    })
  }

  render() {
    let searchBox = this.state.isSearchable &&
      <Row>
        <Col className="mb-4">
          <Form onSubmit={this.searchOffice}>
            <Label for="search">Büro finden</Label>
            <InputGroup>
              <Input type="text" id="search" placeholder="Büroname" innerRef={el => this['search'] = el} />
              <InputGroupButton>
                <Button color="primary" type="submit"><i className="icon-magnifier"></i></Button>
              </InputGroupButton>
            </InputGroup>
          </Form>
        </Col>
      </Row>

    let profileLinks = this.state.results.map(profile =>  {
      return (
        <Card key={`profile-link-${profile.id}`}>
          <Link to={`/profiles/${profile.id}`} className="card-body d-block">
            <CardTitle className="mb-0">{profile.office_name}</CardTitle>
            <div>{profile.address_line_1}</div>
          </Link>
        </Card>
      )
    })

    return this.state.loaded ? (
      <div className="animated fadeIn">
        {searchBox}
        <Row>
          <Col>
            {profileLinks}
          </Col>
        </Row>
      </div>
    ) : null
  }
}

export default Profiles



// WEBPACK FOOTER //
// ./src/views/Profiles/Profiles.js